import { jsx as _jsx } from "react/jsx-runtime";
import { QueueSelect } from './queueSelect';
export const QueueSelectField = (props) => {
    const { input } = props;
    return _jsx(QueueSelect, { selectedQueue: input.value, onSelect: input.onChange });
};
